'use strict';

const estados = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'info',
  OBSERVADO_ENTIDAD_REVISOR: 'warning',
  OBSERVADO_ENTIDAD_FIRMANTE: 'warning',
  FIRMADO_ENTIDAD: 'success',
  REVISADO_CANCILLERIA: 'info',
  OBSERVADO_CANCILLERIA_REVISOR: 'warning',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'warning',
  APOSTILLADO: 'primary'
};

const mensajes = {
  CREADO: 'success',
  REVISADO_ENTIDAD: 'El documento fue enviado correctamente para su posterior firma',
  OBSERVADO_ENTIDAD_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_ENTIDAD_FIRMANTE: 'El documento fue observado correctamente',
  FIRMADO_ENTIDAD: 'El documento fue firmado correctamente',
  REVISADO_CANCILLERIA: 'El documento fue enviado correctamente a cancillería para su verificación',
  OBSERVADO_CANCILLERIA_REVISOR: 'El documento fue observado correctamente',
  OBSERVADO_CANCILLERIA_FIRMANTE: 'El documento fue observado correctamente',
  APOSTILLADO: 'El documento fue apostillado correctamente'
};

export default {
  methods: {
    data () {
      return {
        estados,
        mensajes
      };
    },
    getDocumento (idDocumento) {
      this.$service.graphql({
        query: `
          query get($id: Int!){
            documento(id: $id){
              id
              nombre
              descripcion
              tramite_ppte
              id_entidad
              entidad_nombre
              entidad_descripcion
              entidad_tramite_ppte
              entidad_precio
            }
          }
        `,
        variables: {
          id: idDocumento
        }
      }).then(response => {
        if (response) {
          this.documento = response.documento;
        }
      });
    },
    getArchivo (idArchivo) {
      this.$service.graphql({
        query: `
          query getArchivo($id: Int!){
            archivo(id: $id){
              id
              nombre
              titulo
            }
          }
        `,
        variables: {
          id: idArchivo
        }
      }).then(response => {
        if (response) {
          this.archivo = response.archivo;
        }
      });
    },
    getTramite (idTramite) {
      this.$loading.show('Obteniendo trámite');
      this.$service.graphql({
        query: `
          query tramite ($id: Int!) {
            tramiteDoc(id: $id) {
              id
              pago_entidad
              pago_cancilleria
              cod_seguridad
              nro_apostilla
              fecha_expedicion
              estado
              observacion
              fecha_inicio
              fecha_fin
              firmante_documento_nombre
              firmante_documento_cargo
              firmante_documento_entidad
              digital
              otros
              departamento
              documento_id_entidad
              documento_nombre
              documento_descripcion
              documento_precio
              documento_cuenta
              documento_monto
              documento_entidad_nombre
              documento_entidad_sigla
              documento_duracion
              documento_derivar
              archivo_nombre
              archivo_titulo
              archivo_tamano
              id_documento
              id_archivo
              id_tramite
              tramite_cod_seguimiento
              tramite_fecha_inicio
              tramite_fecha_fin
              tramite_solicitante_id
              tramite_solicitante_nombres
              tramite_solicitante_primer_apellido
              tramite_solicitante_segundo_apellido
              tramite_solicitante_tipo_documento
              tramite_solicitante_nro_documento
              tramite_solicitante_email
              tramite_solicitante_telefono
              tramite_solicitante_fecha_nacimiento
              tramite_solicitante_observacion
            }
            pagos(id_tramite_doc: $id) {
              count
              rows {
                id
                cpt
                tipo
                fecha_pago
                estado
                tipo_documento
                nro_documento
                titular_factura
              }
            }
          }
        `,
        variables: {
          id: idTramite
        }
      }).then(response => {
        if (response) {
          if (this.tramite.id_archivo > 1) {
            this.$loading.show('Renderizando archivo PDF');
            setTimeout(this.$loading.hide, 1200);
          }
          let tramite = response.tramiteDoc;
          tramite.fecha_inicio_show = false;
          tramite.fecha_fin_show = false;
          this.tramite = tramite;

          let fechaInicio, fechaFin;
          if (this.tramite.fecha_inicio) {
            fechaInicio = new Date(this.tramite.fecha_inicio);
          } else {
            // Si no tiene fecha de inicio guardada se la genera automáticamente
            fechaInicio = new Date();
          }
          this.$nextTick(() => {
            this.tramite.fecha_inicio = fechaInicio;
            this.tramite.fecha_inicio_show = true;
          });

          if (this.tramite.fecha_fin) {
            fechaFin = new Date(this.tramite.fecha_fin);
          } else {
            // Si no tiene fecha de fin guardada se la genera automáticamente + los días de validez del documento a apostillar
            fechaFin = new Date(this.$datetime.addDays(fechaInicio, parseInt(this.tramite.documento_duracion)));
          }
          this.$nextTick(() => {
            this.tramite.fecha_fin = fechaFin;
            this.tramite.fecha_fin_show = true;
          });

          this.pagos = response.pagos.rows || [];
          this.url = this.$apiUrl + 'eregister/upload/' + this.tramite.id + '/' + this.tramite.id_archivo;
          this.$store.commit('setArchivo', this.tramite.id_archivo);
        }
      });
    },
    getTramites (filter) { // para TRAMITES
      this.$service.graphql({
        query: `
          query getTramites {
            tramites {
              count
              rows {
                id
                cod_seguimiento
              }
            }
          }
        `,
        variables: {}
      }).then(response => {
        if (response) {
          let items = response.tramites.rows;
          let tramites = [];
          items.map(tramite => {
            tramites.push({ value: tramite.id, text: tramite.cod_seguimiento });
          });
          this.tramites = tramites;
          if (filter && this.filters[filter] && this.filters[filter].items) {
            this.filters[filter].items = this.tramites;
          }
        }
      });
    },
    getPdf (idArchivo) {
      if (idArchivo > 1) {
        this.$loading.show('Cargando documento PDF, espere por favor...');
        this.$service.post('eregister/pdf', { id_archivo: idArchivo })
        .then(response => {
          if (response === null) {
            return null;
          }
          this.pdf = response;
          this.urlPdf = `${this.$apiUrl}eregister/pdf-download/${idArchivo}`;
        });
      }
    },
    getDocumentos (filter) { // para DOCUMENTOS
      this.$service.graphql({
        query: `
          query getDocumentos {
            documentos {
              count
              rows {
                id
                nombre
                descripcion
              }
            }
          }
        `,
        variables: {}
      }).then(response => {
        if (response) {
          let items = response.documentos.rows;
          let documentos = [{ value: '', text: 'TODOS' }];
          items.map(documento => {
            documentos.push({ value: documento.id, text: `${documento.nombre} - ${documento.descripcion}` });
          });
          this.documentos = documentos;
          if (filter !== undefined && this.filters[filter] && this.filters[filter].items) {
            this.filters[filter].items = this.documentos;
          }
        }
      });
    },
    getArchivos (filter) { // para ARCHIVOS
      this.$service.graphql({
        query: `
          query getArchivos {
            archivos {
              count
              rows {
                id
                cod_seguimiento
              }
            }
          }
        `,
        variables: {}
      }).then(response => {
        if (response) {
          let items = response.archivos.rows;
          let archivos = [];
          items.map(archivo => {
            archivos.push({ value: archivo.id, text: archivo.nombre });
          });
          this.archivos = archivos;
          if (filter && this.filters[filter] && this.filters[filter].items) {
            this.filters[filter].items = this.archivos;
          }
        }
      });
    },
    actualizarEstadoTramiteDoc (solicitud, estado, observacion, tipoInst) {
      if (estado === 'REVISADO_ENTIDAD' && solicitud.id_archivo === 1) {
        this.$message.warning('Tiene que agregar un documento PDF para ser apostillado');
        return false;
      }

      this.$service.graphql({
        query: `
          mutation edit($id: Int!, $tramiteDoc: EditTramiteDoc!) {
            tramiteDocEdit(id: $id, tramiteDoc: $tramiteDoc) {
              id
            }
          }
        `,
        variables: {
          id: solicitud.id,
          tramiteDoc: {
            estado,
            observacion,
            firmante_documento_nombre: solicitud.firmante_documento_nombre,
            firmante_documento_cargo: solicitud.firmante_documento_cargo,
            firmante_documento_entidad: solicitud.firmante_documento_entidad,
            departamento: solicitud.departamento,
            fecha_inicio: this.$store.state.date.fecha_inicio,
            fecha_fin: this.$store.state.date.fecha_fin
          }
        }
      }).then(response => {
        if (response) {
          this.$message.success(mensajes[estado]);
          this.$store.commit('closeModal', 2);
          document.querySelector('#btn-refresh-list').dispatchEvent(new window.Event('click'));
        }
      });
    },
    generarCpt (item, tipoInstitucion, callback) {
      let fechaNac = item.tramite_solicitante_fecha_nacimiento.split('-');
      let fechaNac2 = [fechaNac[2], fechaNac[1], fechaNac[0]].join('/');
      let datos = {
        cpt_ppte: {
          numeroDocumento: item.tramite_solicitante_nro_documento,
          tipoDocumento: item.tramite_solicitante_tipo_documento,
          nombre: `${item.tramite_solicitante_nombres} ${item.tramite_solicitante_primer_apellido} ${item.tramite_solicitante_segundo_apellido}`,
          fechaNacimiento: fechaNac2,
          complemento: '',
          transicion: 'crear',
          monto: item.documento_monto
        },
        datos_tramite_apostilla: {
          id_documento: item.id_documento,
          id_tramite: item.id_tramite,
          id_usuario: this.$store.state.user.id,
          email: item.tramite_solicitante_email,
          id_tramite_doc: parseInt(item.id),
          tipo_institucion: tipoInstitucion,
          id_rol: this.$store.state.user.id_rol,
          id_entidad: this.$store.state.user.id_entidad
        }
      };
      this.$service.post(`eapostilla/generar_cpt`, datos)
      .then(response => {
        if (response) {
          this.$message.success('Se generó el Código de Pago(CPT) correctamente y se le envió al solicitante para que realice su pago.');
          if (typeof callback === 'function') {
            callback();
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/eRegister/tramiteDoc/mixins/tramite_doc.js